import { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../core/components/Loader';
import { FETCH_AVERAGE_RATING, fetchAverageRating } from '../actions';
import { selectAverageRating } from '../reducer';
import { selectCoreSiteId } from '../../settings/reducer';
import { selectApiRequests } from '../../../store/apiRequestReducer';
import { OVERVIEW_YELLOW } from '../containers/Charts';

export const GuestRatingKpi = () => {
  const intl = useIntl();
  const maxRating = 5;
  const dispatch = useDispatch();
  const siteId = useSelector(selectCoreSiteId);
  const averageRating = useSelector(selectAverageRating);
  const rating = averageRating ?? 0;
  const isLoading = useSelector((state) => {
    const req = selectApiRequests(state)[FETCH_AVERAGE_RATING];
    return !req || req.isLoading;
  });
  const [ratingValues, setRatingValues] = useState(new Array(maxRating).fill(0));
  useEffect(() => {
    if (siteId) {
      dispatch(fetchAverageRating());
    }
  }, [siteId]);
  useEffect(() => {
    if (rating >= 0 && rating <= maxRating) {
      const stars = new Array(5).fill(0);
      const whole = Math.floor(rating);
      const decimal = Math.round((rating - whole) * 2) / 2; // rounding to nearest half
      stars.fill(1, 0, whole);
      if (whole < maxRating) stars[whole] = decimal;
      setRatingValues(stars);
    }
  }, [rating]);
  return (
    <section className="overview-chart-card guest-rating">
      <p className="chart-title">{intl.formatMessage({ id: 'guestRatingTitle' })}</p>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <span className="rating">
            {Math.round(rating * 10) / 10}
            <span>/ {maxRating}</span>
          </span>
          <div className="stars">
            {ratingValues.map((v: number) => (
              <div className="star">
                <FaStar />
                <div style={{ width: `${v * 100}%` }} className="clipped-star">
                  <FaStar style={{ fill: OVERVIEW_YELLOW }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <p className="rating-explanation">
        {rating === 0
          ? intl.formatMessage({ id: 'guestRatingNoReviews' })
          : intl.formatMessage({ id: 'guestRatingBasedOn' })}
      </p>
    </section>
  );
};
